"use strict";
/**
 * Do not edit directly
 * This file is automatically generated
 **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLORS = void 0;
exports.COLORS = {
    "BLACK": {
        "100": "#606b85",
        "200": "#5c657a",
        "300": "#515b71",
        "400": "#4b5367",
        "500": "#424a5c",
        "600": "#3f4450",
        "700": "#383b42",
        "800": "#232529",
        "900": "#000000"
    },
    "BLUE": {
        "100": "#e7f5fc",
        "200": "#b8e0f6",
        "300": "#88ccf1",
        "400": "#70c2ee",
        "500": "#41ade8",
        "600": "#1A96DA",
        "700": "#126999",
        "800": "#0d4b6d",
        "900": "#051e2c"
    },
    "GRADIENT": {
        "RAINBOW-HORIZONTAL": "linear-gradient(90deg, #a51cf1 0%, #336dff 10%, #31bbfd 20%, #36d3e6 30%, #1decbb 40%, #b9eb4d 50%, #ffda19 60%, #ff781d 70%, #ff2055 80%, #e40aaf 90%, #a51cf1 100%)",
        "PINK": "linear-gradient(134deg, #ce55b0 0%, #f34dac 40.62%, #f48e66 87.06%)",
        "GREEN": "linear-gradient(134deg, #b2ce37 0%, #63d7af 91.96%)",
        "BLUE": "linear-gradient(135deg, #63d7af 0%, #1cc2df 50%, #0580e6 100%)",
        "PURPLE": "linear-gradient(132deg, #0580e6 0%, #f34dac 98.73%)"
    },
    "GREEN": {
        "100": "#f2faeb",
        "200": "#d7f0c2",
        "300": "#bce699",
        "400": "#afe085",
        "500": "#94d65c",
        "600": "#79CC33",
        "700": "#558f24",
        "800": "#3d6619",
        "900": "#18290a"
    },
    "PEACH": {
        "100": "#ffeee8",
        "200": "#ffceba",
        "300": "#ffac8d",
        "400": "#ff9c76",
        "500": "#ff7b48",
        "600": "#FF5A1A",
        "700": "#c53700",
        "800": "#8d2700",
        "900": "#381000"
    },
    "PINK": {
        "100": "#fde7f4",
        "200": "#fab7de",
        "300": "#f788c8",
        "400": "#f570bc",
        "500": "#f240a6",
        "600": "#EF1090",
        "700": "#a70b65",
        "800": "#780848",
        "900": "#30031d"
    },
    "PURPLE": {
        "100": "#efecfb",
        "200": "#d0c5f2",
        "300": "#b19fe9",
        "400": "#a18ce5",
        "500": "#8265dc",
        "600": "#633fd3",
        "700": "#41249c",
        "800": "#2e1a6f",
        "900": "#130a2d"
    },
    "TEAL": {
        "100": "#eafaf4",
        "200": "#c1efdf",
        "300": "#98e4ca",
        "400": "#83dfbf",
        "500": "#59d5aa",
        "600": "#33C794",
        "700": "#248b68",
        "800": "#1a644a",
        "900": "#0a281e"
    },
    "WHITE": {
        "100": "#ffffff",
        "200": "#f5f6fa",
        "300": "#ebeef5",
        "400": "#d3dae8",
        "500": "#c0c7d8",
        "600": "#b2bacc",
        "700": "#a6aebf",
        "800": "#a6aebf",
        "900": "#8d94a5"
    },
    "YELLOW": {
        "100": "#fff8e6",
        "200": "#fee9b5",
        "300": "#feda84",
        "400": "#fdd26b",
        "500": "#fdc339",
        "600": "#FCB408",
        "700": "#b47f02",
        "800": "#805b02",
        "900": "#332401"
    }
};
